import React from 'react';
import {NavLink} from 'react-router-dom';
import article_styles from './content.module.css';
import PageLink from '../../../PageLink/PageLink.js';
import ContentTitle from '../../../ContentTitle/ContentTitle.js';
import ContentDescription from '../../../ContentDescription/ContentDescription.js';
import CONSTANTS from '../../../../constants/constants';
import { DateUtil } from '../../../../utils/DateUtil';

const Content=(props)=>{
	let image_background=null,
		image_text=null,
		image_size=(props.feature===true?'':'resize=1&width=525');

	if(props.image_type==='CLOSE' && props.data.Metadata.preview_close)
		image_background=(<img alt="" src={`${window.global.content_hub.ASSETS}images/${props.data.Metadata.preview_close}?${image_size}`}/>);
	else if(props.image_type==='SQUARE' && props.data.Metadata.preview_square)
		image_background=(<img alt="" src={`${window.global.content_hub.ASSETS}images/${props.data.Metadata.preview_square}?${image_size}`}/>);
	else if(props.data.Metadata.header_banner){
		image_background=(<img alt="" src={`${window.global.content_hub.ASSETS}images/${props.data.Metadata.header_banner}?${image_size}`}/>);
		if(props.feature===true && props.data.Metadata.header_text)
			image_text=(<img alt="" src={`${window.global.content_hub.ASSETS}images/${props.data.Metadata.header_text}`}/>);
	}

	let styles={...article_styles};
	Object.keys(props.content_styles || {}).forEach(k=>{
		styles[k]=(styles[k]===undefined?'':styles[k]+' ')+props.content_styles[k];
	});
	Object.keys(props.layout_styles || {}).forEach(k=>{
		styles[k]=(styles[k]===undefined?'':styles[k]+' ')+props.layout_styles[k];
	});

	return(
		<NavLink to={`${CONSTANTS.PAGE_CONTENT}/${props.data.ID}`} style={{width:'100%'}}>
			<div className={[styles.container,props.read_more===true?styles.read_more:null].join(' ')}>
				<div className={styles.header_image}>
					<div className={styles.image_container}>
						{image_background}
						{image_text}
					</div>
				</div>
				<div className={styles.content_container}>
					<ContentTitle 
						published_date={props.author!==false && props.data.Metadata.published_date?DateUtil.formatDateOnly(props.data.Metadata.published_date):undefined}
						title={props.data.Title} styles={styles} 
					/>
					<ContentDescription description={props.feature===true?props.data.Description:props.data.DescriptionSML} styles={styles} feature={props.feature}/>
					{props.read_more===true
						?<div className={styles.link}>
							<PageLink open={props.open} label="Read more"/>
						</div>
					:null}
				</div>
			</div>
		</NavLink>
	);
};

export default Content;
